import { useAppSelector } from '../../effects/useAppSelector';
import { LoanArrangerBankLink } from './LoanArrangerBankLink';
import { LoanCoArrangersPopover } from './LoanCoArrangersPopover';
import { constants } from '../../constants';

interface Props {
    issuer: string;
    coArrangers: string[];
}

export function LoanCoArrangerBankLinks({ issuer, coArrangers }: Props) {
    const arrangers = useAppSelector(s => s.entities.arrangers.items);
    const debtInvestors = useAppSelector(s => s.entities.debtInvestors.items);
    const collateralManagers = useAppSelector(s => s.entities.collateralManagers.items);

    const knownCoArrangers = coArrangers.filter(
        referenceName => arrangers[referenceName] ?? debtInvestors[referenceName] ?? collateralManagers[referenceName],
    );

    if (!knownCoArrangers.length) {
        return <>{constants.emptyPlaceholder}</>;
    }

    if (knownCoArrangers.length === 1) {
        return <LoanArrangerBankLink companyReferenceName={knownCoArrangers[0]} />;
    }

    return <LoanCoArrangersPopover issuer={issuer} coArrangers={knownCoArrangers} />;
}
